<template>
  <v-card id='start'>
    <v-app-bar
    elevation="21"
    color="primary"
    height="75px"
    align='center' >

      <a style="cursor: pointer;" @click="$router.push('/')" class='logo'>
        betamatch
      </a>


      <v-tabs right grow align-with-title class='d-none d-sm-flex' color='white'>
        <v-tabs-slider color="white"></v-tabs-slider>
          <v-tab
            v-for="item in menu_options"
            :key="item.name"
            :to="item.href"
            class="white--text"
          >{{item.name}}</v-tab>
      </v-tabs>

      <v-spacer></v-spacer>

      <v-menu v-model="languageMenu" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="white" class="text-capitalize" v-bind="attrs" v-on="on" text>
            <v-icon left>mdi-translate</v-icon>
            {{ activeLang }}
            <v-icon small right>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item v-for="(lang, index) in langs" :key="index" @click="handleMenuItemClick(lang)">
            <v-list-item-title>{{ lang.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

        <v-divider vertical style="margin-left:10px; margin-right:10px;"></v-divider>

      <v-btn color='secondary primary--text' :to="{ name: 'Login'}">
        {{login_btn_text}}
      </v-btn>
    
    </v-app-bar>

    <!-- Mobile Navigation Drawer -->
    <v-navigation-drawer v-model="drawer" absolute temporary color='secondary'>
      <v-list nav dense>
        <v-list-item-group>
          <v-list-item v-for="(item, index) in mobile_menu_options" :key="item.id"
          :to="item.href">
            <v-list-item-title class="mobileMenu"
            @click="tab = index">
              {{ item.name }}
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

  </v-card>
</template>

<script>
import { mapActions } from 'vuex';


export default {
    name: 'AppNavigation',
    data() {
        return {
          // Flags
          drawer: false,
          tab: null,
          languageMenu: false,

          langs: [
            { title: 'English', code: 'en' },
            { title: 'Български', code: 'bg' },
            // { title: 'Türk', code: 'tr' }
          ],
        };
    },
    computed: {
      login_btn_text() {
        return this.$store.state.language.locale[this.$store.getters.userLang.code].header_menu.platform
      },
      menu_options() {
        return [
              { name: this.$store.state.language.locale[this.$store.getters.userLang.code].header_menu.about_us, href:"/#about"},
              { name: this.$store.state.language.locale[this.$store.getters.userLang.code].header_menu.services, href:"/#services"},
              // { name: this.$store.state.language.locale[this.$store.getters.userLang.code].header_menu.news, href:"/news"},
              { name: this.$store.state.language.locale[this.$store.getters.userLang.code].header_menu.contact, href:"/#contacts"},
            ]
      },
      mobile_menu_options() {
        return [
              { name: this.$store.state.language.locale[this.$store.getters.userLang.code].header_menu.platform, href:"/login"},
              { name: this.$store.state.language.locale[this.$store.getters.userLang.code].header_menu.about_us, href:"/#about"},
              { name: this.$store.state.language.locale[this.$store.getters.userLang.code].header_menu.services, href:"/#services"},
              { name: this.$store.state.language.locale[this.$store.getters.userLang.code].header_menu.contact, href:"/#contacts"},
            ]
      },
      activeLang() {
        return (this.$store.getters.userLang).title
      }
    },
    methods: {
      ...mapActions(['changeLanguage']),
      async handleMenuItemClick (lang) {
        await this.changeLanguage(lang);
      },
    }
};
</script>

<style scoped>

.mobileMenu {
  font-size: 18px;
  font-weight: 700;
  text-align: justify;
}

.logo {
  /* font-family: 'Roboto'; */
  font-weight: 700;
  font-size: 32px;
  color: white;
  text-decoration: none;
}

</style>